// Phase 2 — Business Profile Assessment configuration & helpers

export const OPERATING_BASE_OPTIONS = [
  "Rumah", "Ruko/tempat milik sendiri", "Tempat sewa", "Online", "Mobile/berpindah-pindah", "Belum tahu",
];

export const INTEREST_OPTIONS = [
  "Kuliner", "Perdagangan / Reselling", "Jasa", "Online Selling", "Digital / Produk Digital",
  "Pendidikan / Training", "Kreatif", "Pertanian / Produksi Lokal", "B2B / Bisnis ke Bisnis",
  "Belum punya preferensi", "Lainnya",
];

export const SKILL_OPTIONS = [
  "Memasak", "Penjualan", "Komunikasi", "Negosiasi", "Social Media", "Digital Marketing",
  "Desain", "Administrasi", "Keuangan dasar", "Mengajar / Training", "Operasional",
  "Produksi", "Teknologi / IT", "Business Development", "Customer Service", "Lainnya",
];

export const EXPERIENCE_OPTIONS = [
  "Belum pernah menjalankan bisnis",
  "Pernah membantu bisnis keluarga/orang lain",
  "Pernah menjalankan usaha kecil",
  "Sedang menjalankan bisnis",
  "Memiliki pengalaman bisnis yang cukup kuat",
];

export const TIME_OPTIONS = [
  "Kurang dari 1 jam per hari", "1–2 jam per hari", "2–4 jam per hari",
  "4–6 jam per hari", "Full-time, sekitar 8 jam per hari", "Jadwal fleksibel / tidak tetap",
];

export const TEAM_OPTIONS = [
  "Saya sendiri", "Saya + pasangan/keluarga", "Saya + partner", "Sudah memiliki tim", "Belum tahu",
];

export const ASSET_OPTIONS = [
  "Smartphone", "Laptop / komputer", "Motor", "Mobil", "Dapur rumah", "Kulkas / freezer",
  "Ruang kosong di rumah", "Toko / ruko milik sendiri", "Peralatan produksi", "Jaringan customer",
  "Jaringan supplier", "Akun social media", "Lainnya", "Tidak ada aset khusus",
];

export const GOAL_OPTIONS = [
  "Penghasilan tambahan", "Menggantikan penghasilan utama", "Membangun bisnis jangka panjang",
  "Memanfaatkan skill/aset yang dimiliki", "Menguji peluang bisnis terlebih dahulu", "Lainnya",
];

export const INCOME_OPTIONS = [
  "Di bawah Rp1 juta/bulan", "Rp1–3 juta/bulan", "Rp3–5 juta/bulan",
  "Rp5–10 juta/bulan", "Rp10–20 juta/bulan", "Di atas Rp20 juta/bulan", "Belum menentukan target",
];

export const MODE_OPTIONS = ["Offline", "Online", "Hybrid", "Fleksibel / tidak ada preferensi"];

export const PRIORITY_OPTIONS = [
  "Cashflow cepat", "Risiko rendah", "Modal kecil", "Margin potensial lebih tinggi",
  "Mudah dijalankan", "Bisa berkembang / scalable", "Waktu fleksibel",
];

export const RISK_OPTIONS = [
  { value: "Conservative", label: "Conservative", desc: "Saya lebih memilih risiko modal rendah walaupun pertumbuhan mungkin lebih lambat." },
  { value: "Moderate", label: "Moderate", desc: "Saya bersedia mengambil risiko terukur jika peluangnya masuk akal." },
  { value: "Aggressive", label: "Aggressive", desc: "Saya lebih terbuka mengambil risiko lebih besar untuk mengejar peluang pertumbuhan." },
];

export const SECTIONS = [
  { id: 1, title: "Lokasi & Cara Beroperasi" },
  { id: 2, title: "Modal" },
  { id: 3, title: "Minat & Kemampuan" },
  { id: 4, title: "Waktu & Tim" },
  { id: 5, title: "Aset & Tujuan" },
  { id: 6, title: "Preferensi & Batasan" },
];

export const TOTAL_STEPS = SECTIONS.length;

export const EMPTY_ANSWERS = {
  business_location: "",
  operating_base: "",
  available_capital: null,
  capital_reserve: null,
  business_interests: [],
  business_interests_other: "",
  skills: [],
  skills_other: "",
  business_experience: "",
  business_experience_note: "",
  available_time: "",
  available_time_note: "",
  team_structure: "",
  team_structure_note: "",
  available_assets: [],
  available_assets_other: "",
  primary_goal: "",
  primary_goal_other: "",
  income_target: "",
  business_mode: "",
  business_priorities: [],
  risk_tolerance: "",
  additional_constraints: "",
};

// ---- currency helpers (IDR) ----
export function formatRupiah(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  if (Number.isNaN(n)) return "";
  return "Rp " + n.toLocaleString("id-ID");
}

export function parseRupiah(str) {
  const digits = String(str).replace(/[^0-9]/g, "");
  return digits === "" ? null : Number(digits);
}

export function deployableCapital(available, reserve) {
  return Math.max((Number(available) || 0) - (Number(reserve) || 0), 0);
}

// Required fields for completing the profile: field -> { label, step }
export const REQUIRED_FIELDS = [
  { field: "business_location", label: "Lokasi bisnis", step: 1 },
  { field: "operating_base", label: "Cara beroperasi", step: 1 },
  { field: "available_capital", label: "Total modal", step: 2 },
  { field: "capital_reserve", label: "Dana cadangan", step: 2 },
  { field: "business_interests", label: "Bidang minat", step: 3 },
  { field: "business_experience", label: "Pengalaman bisnis", step: 3 },
  { field: "available_time", label: "Ketersediaan waktu", step: 4 },
  { field: "team_structure", label: "Struktur tim", step: 4 },
  { field: "primary_goal", label: "Tujuan utama", step: 5 },
  { field: "income_target", label: "Target penghasilan", step: 5 },
  { field: "business_mode", label: "Model bisnis", step: 6 },
  { field: "business_priorities", label: "Prioritas bisnis", step: 6 },
  { field: "risk_tolerance", label: "Toleransi risiko", step: 6 },
];

function isEmptyValue(v) {
  if (v === null || v === undefined) return true;
  if (typeof v === "string") return v.trim() === "";
  if (Array.isArray(v)) return v.length === 0;
  return false;
}

// Returns array of { field, label, step } for missing required fields.
export function findMissingRequired(a) {
  return REQUIRED_FIELDS.filter(({ field }) => isEmptyValue(a[field]));
}

// Per-step validation. Returns error string or null.
export function validateStep(step, a) {
  switch (step) {
    case 1:
      if (!a.business_location?.trim()) return "Mohon isi lokasi bisnis Anda.";
      if (!a.operating_base) return "Pilih dari mana Anda menjalankan bisnis.";
      return null;
    case 2:
      if (a.available_capital === null || a.available_capital === "") return "Mohon isi total modal yang tersedia.";
      if (a.capital_reserve === null || a.capital_reserve === "") return "Mohon isi dana cadangan (isi 0 jika tidak ada).";
      if (Number(a.available_capital) < 0 || Number(a.capital_reserve) < 0) return "Nilai modal tidak boleh negatif.";
      if (Number(a.capital_reserve) > Number(a.available_capital)) return "Dana cadangan tidak boleh melebihi total modal.";
      return null;
    case 3:
      if (a.business_interests.length === 0) return "Pilih minimal 1 bidang bisnis yang menarik.";
      if (a.business_interests.length > 3) return "Pilih maksimal 3 bidang bisnis.";
      if (!a.business_experience) return "Pilih tingkat pengalaman bisnis Anda.";
      return null;
    case 4:
      if (!a.available_time) return "Pilih ketersediaan waktu Anda.";
      if (!a.team_structure) return "Pilih siapa yang akan menjalankan bisnis.";
      return null;
    case 5:
      if (!a.primary_goal) return "Pilih tujuan utama Anda.";
      if (!a.income_target) return "Pilih target penghasilan Anda.";
      return null;
    case 6:
      if (!a.business_mode) return "Pilih model bisnis yang Anda inginkan.";
      if (a.business_priorities.length === 0) return "Pilih minimal 1 prioritas terpenting.";
      if (a.business_priorities.length > 2) return "Pilih maksimal 2 prioritas.";
      if (!a.risk_tolerance) return "Pilih tingkat toleransi risiko Anda.";
      return null;
    default:
      return null;
  }
}
